export const COPIED_FEEDBACK_MS = 1500;
